// extracted by mini-css-extract-plugin
export default {"container":"Translation_container__0kJeb","animationButton":"Translation_animationButton__g9p4-"};